import React from "react";
import "./AboutMe.css";

import pic1 from "../../assets/fritid.jpg";
import pic2 from "../../assets/fritid7.jpg";
import pic3 from "../../assets/fritid2.jpg";
import pic4 from "../../assets/fritid3.jpeg";
import pic5 from "../../assets/fritid4.jpg";
import pic6 from "../../assets/fritid5.jpg";
import pic7 from "../../assets/fritid6.jpg";
import pic8 from "../../assets/fritid8.jpg";

function AboutMe() {
  const hobbies = [
    { text: "Sunbathing in the summer with friends", img: pic1, alt: "Travel", size: "lg" },
    { text: "Love to paint", img: pic2, alt: "Outdoors", size: "sm" },
    { text: "My favorite to spend time with", img: pic3, alt: "Fika", size: "md" },
    { text: "Have a drink in the sun", img: pic4, alt: "Travel 2", size: "sm" },
    { text: "Eat lots of food", img: pic5, alt: "Outdoors 2", size: "md" },
    { text: "Watch sports events", img: pic6, alt: "Fika 2", size: "lg" },
    { text: "Being outdoors", img: pic7, alt: "Outdoors 3", size: "sm" },
    { text: "A picnic in the sun", img: pic8, alt: "Fika 3", size: "md" },
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-top">
        <div className="about-left">
          <h2>From Passion to Profession</h2>
          <p>
            My passion for tech and design has been with me since childhood and has only deepened over time.
            In June 2024, I completed a master’s degree in interaction, technology, and design, where I developed
            my skills in both programming and design. My primary focus is always on the end user, ensuring I create
            the most effective and engaging user experiences.
          </p>
        </div>

        <div className="about-right">
          <h3>Tools I have used</h3>
          <p>
            Figma, Adobe Photoshop and Adobe Illustrator<br />
            HTML, CSS, JavaScript, React.js, Java, C#, C, SQL, ASP.NET, Next.js and Python
          </p>
        </div>
      </div>

      <div className="about-bottom">
        <h3>In my freetime, I enjoy…</h3>

        <div className="hobbies-grid">
          {hobbies.map((h, idx) => (
            <figure key={idx} className={`hobbyCard size-${h.size}`}>
              <div className="hobbyImgWrap">
                <img src={h.img} alt={h.alt} loading="lazy" />
              </div>
              <figcaption className="hobbyText">
                {h.text.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    {i !== h.text.split("\n").length - 1 && <br />}
                  </span>
                ))}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutMe;

